import React from "react";

const Card = ({ children }) => {
  return (
    <div className="relative rounded-[20px] bg-white shadow-[0px_0px_8px_rgba(166,166,166,0.25)] px-6 py-8 mt-9 font-custom">
      {children}
    </div>
  );
};

export default Card;
